export function showFlashMessage(uuid, variant, message, time) {
  if (flashMessages === undefined) {
    return;
  }
  let html = message;
  let focus = null;
  let fields = null;
  if (message && typeof message === 'object') {
    html = message.html ?? message.message ?? '';
    focus = message.focus ?? message.field ?? message.selector ?? null;
    fields = Array.isArray(message.fields) ? message.fields : null;
  }
  // Check if the message with the given UUID already exists
  if (document.getElementById(uuid)) {
    return;
  }
  var template = `[data-flash-template-variant='${variant}']`;
  template = document.querySelector(template);
  if (template === null) {
    return
  }
  if (uuid === undefined || uuid === null) {
    uuid = crypto.randomUUID();
  }
  // create new Div
  var div = template.cloneNode(true).children[0];
  div.id = uuid;
  const slot = div.querySelector('[data-message-slot]');
  slot.innerHTML = html;
  if (fields) {
    slot.append(` ${fields.map(fieldErrorText).join(', ')}`);
  }
  div.querySelector('[data-message-dismiss]').dataset.messageId = uuid;
  flashMessages.appendChild(div);
  window.htmx.process(div);
  flashMessages.classList.remove('hidden');
  if (focus) {
    setTimeout(() => {
      const target = resolveFocusTarget(focus);
      if (target) {
        highlightAndScrollTo(target);
      }
    }, 50);
  }
  // Set up timeout
  let total = time;
  let countdownElement = div.querySelector('small[data-countdown]');
  if (countdownElement) {
    countdownElement.innerHTML = `(${total})`;
  }

  function down() {
    let msg = document.getElementById(uuid);
    if (msg) {
      flashMessages.classList.remove('hidden');
      total -= 1;
      countdownElement.innerHTML = `(${total})`;
      if (total <= 0) {
        dismissFlashMessage(
          div.querySelector('[data-message-dismiss]')
        );
      } else {
        setTimeout(down, 1000);
      }
    }
  }
  setTimeout(down, 100);
}

export function dismissFlashMessage(el) {
  var msg = document.getElementById(el.dataset.messageId);
  if (msg) {
    msg.remove();
    if (flashMessages === undefined){
      return;
    }
    if (flashMessages.querySelectorAll('[data-message-id]').length === 0) {
      flashMessages.classList.add('hidden');
    }
  }
}

function resolveFocusTarget(focus) {
  if (!focus || typeof focus !== 'string') return null;
  const sel = focus.trim();
  if (!sel) return null;

  // If it looks like a selector, use it as-is.
  if (sel.startsWith('#') || sel.startsWith('.') || sel.startsWith('[')) {
    return document.querySelector(sel);
  }

  // Otherwise treat it like a field name first, then fallback to id.
  try {
    const escaped = (window.CSS && CSS.escape) ? CSS.escape(sel) : sel;
    return (
      document.querySelector(`[name='${escaped}']`) ||
      document.getElementById(sel)
    );
  } catch {
    return document.querySelector(`[name='${sel}']`) || document.getElementById(sel);
  }
}

// Server validation only knows form field names; dataform labels come from each
// page's layout, so read the label the user actually sees next to the field.
function fieldErrorText({ name, label, message }) {
  const text = (name && pageLabel(name)) || label;
  return message ? `${text} - ${message}` : text;
}

function pageLabel(name) {
  const field = resolveFocusTarget(name);
  if (!field) return '';
  let label = [field.id, `${name}_input`]
    .filter(Boolean)
    .map((id) => document.querySelector(`label[for="${CSS.escape(id)}"]`))
    .find(Boolean);
  // Several field templates point `for` at the field type, so fall back to the
  // label inside the field's own wrapper, only when that wrapper has exactly one.
  for (let parent = field.parentElement, depth = 0; !label && parent && depth < 4; parent = parent.parentElement, depth += 1) {
    const labels = parent.querySelectorAll('label');
    if (labels.length > 1) break;
    label = labels[0];
  }
  if (!label) return '';
  const copy = label.cloneNode(true);
  copy.querySelectorAll('.text-red-500, [tabindex], svg').forEach((el) => el.remove());
  return copy.textContent.replace(/\s+/g, ' ').replace(/[\s*:]+$/, '').trim();
}

function isFilled(el) {
  const v = el?.value;
  if (v === undefined || v === null) return true;
  const s = String(v).trim();
  if (!s) return false;
  // For common numeric-required fields, treat zero as not-filled.
  if (s === '0' || s === '0.0' || s === '0.00') return false;
  return true;
}

function highlightAndScrollTo(el) {
  try {
    el.classList.add('ssr-missing-required');
  } catch {}

  try {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } catch {}

  try {
    setTimeout(() => {
      el.focus?.();
    }, 250);
  } catch {}

  const clear = () => {
    if (isFilled(el)) {
      try {
        el.classList.remove('ssr-missing-required');
      } catch {}
      el.removeEventListener('input', clear);
      el.removeEventListener('change', clear);
    }
  };
  el.addEventListener('input', clear);
  el.addEventListener('change', clear);
}
